module.exports = __webpack_public_path__ + "img/drugs.9620629f.svg";